import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const PageLoader = ({ text = "Loading..." }) => {
  return (
    <Box
      sx={{
        minHeight: 260,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
      }}
    >
      <CircularProgress size={34} />
      <Typography variant="body2" color="text.secondary">
        {text}
      </Typography>
    </Box>
  );
};

export default PageLoader;
